import axios from 'axios';

const API_BASE_URL = 'https://keitoferias.dyndns.org/KeitoSalesWS';

export const createUser = async (email, contraseña) => {
    const url = `${API_BASE_URL}/createUser`;
    const body = {
        email: email,
        contraseña: contraseña
    };
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };
    try {
        const response = await axios.post(url, body, config);
        return response.data;
    } catch (error) {
        console.error('Error creating user:', error);
        throw error;
    }
};

export const authenticateUser = async (email, contraseña) => {
    const url = `${API_BASE_URL}/authenticate`;
    const body = {
        email: email,
        contraseña: contraseña
    };
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };
    try {
        const response = await axios.post(url, body, config);
        return response.data;
    } catch (error) {
        console.error('Error authenticating user:', error);
        throw error;
    }
};

export const registerContact = async (contactData, token) => {
    const url = `${API_BASE_URL}/registrar-contacto`;
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    };
    try {
        const response = await axios.post(url, contactData, config);
        return response.data;
    } catch (error) {
        console.error('Error registering contact:', error);
        throw error;
    }
};

export const getUserWithContacts = async (token) => {
    const url = `${API_BASE_URL}/contactos`;
    const config = {
        headers: {
            Authorization: `Bearer ${token}`
        }
    };
    try {
        const response = await axios.get(url, config);
        return response.data;
    } catch (error) {
        console.error('Error getting user with contacts:', error);
        throw error;
    }
};

export const removeContact = async (contactId, token) => {
    const url = `${API_BASE_URL}/contactos/${contactId}`;
    const config = {
        headers: {
            Authorization: `Bearer ${token}`
        }
    };
    try {
        const response = await axios.delete(url, config);
        return response.data;
    } catch (error) {
        console.error('Error removing contact:', error);
        throw error;
    }
};

export const updateContact = async (contactId, contactData, token) => {
    const url = `${API_BASE_URL}/contactos/${contactId}`;
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    };
    try {
        const response = await axios.put(url, contactData, config);
        return response.data;
    } catch (error) {
        console.error('Error updating contact:', error);
        throw error;
    }
};

export const checkToken = async (token) => {
    const url = `${API_BASE_URL}/check-token`;
    const config = {
        headers: {
            Authorization: `Bearer ${token}`
        }
    };
    try {
        const response = await axios.get(url, config);
        return response.data;
    } catch (error) {
        console.error('Error checking token:', error);
        throw error;
    }
};

export const getFerias = async (token) => {
    const url = `${API_BASE_URL}/ferias`;
    const config = {
        headers: {
            Authorization: `Bearer ${token}`
        }
    }

    try {
        const response = await axios.get(url, config);
        return response.data;
    } catch (error) {
        console.error('Error getting ferias:', error);
        throw error;
    }
};

export const regOrder = async (orderData, token) => {
    const url = `${API_BASE_URL}/registrar-contacto`;
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    };
    try {
        const response = await axios.post(url, orderData, config);
        return response.data;
    } catch (error) {
        console.error('Error registering contact:', error);
        throw error;
    }
};

export const updateOrder = async (orderId, orderData, token) => {
    const url = `${API_BASE_URL}/contactos/${orderId}`;
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    };
    try {
        const response = await axios.put(url, orderData, config);
        return response.data;
    } catch (error) {
        console.error('Error updating contact:', error);
        throw error;
    }
};

export const getOrder = async (token) => {
    const url = `${API_BASE_URL}/contactos`;
    const config = {
        headers: {
            Authorization: `Bearer ${token}`
        }
    };
    try {
        const response = await axios.get(url, config);
        return response.data;
    } catch (error) {
        console.error('Error getting user with contacts:', error);
        throw error;
    }
};

export const deleteOrder = async (orderId, token) => {
    const url = `${API_BASE_URL}/contactos/${orderId}`;
    const config = {
        headers: {
            Authorization: `Bearer ${token}`
        }
    };
    try {
        const response = await axios.delete(url, config);
        return response.data;
    } catch (error) {
        console.error('Error removing contact:', error);
        throw error;
    }
};
